import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import ColumnChart from "@/shared/components/charts/ColumnChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import {
  makeChartHumidityRiskTitle,
  mapRiskToChartData,
} from "@/features/reports/presentation/components/cropping-pattern/utils/temperature-risk-charts";

interface HumidityRisksProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
}

const HumidityRisks = ({ croppingSuitabilityReports }: HumidityRisksProps) => {
  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={8}>
      <div className="w-full flex flex-col justify-between ic">
        <div className="w-full flex flex-col justify-center items-center my-3">
          <Title>ریسک‌های رطوبتی</Title>
          <div className=" w-full flex flex-col justify-center items-center mt-5">
            <div className="w-[400px] flex items-center justify-center gap-y-3 my-2">
              {croppingSuitabilityReports?.map(({ crop, humidityRisks }) =>
                humidityRisks?.map((risk, i) => (
                  <ColumnChart
                    key={i}
                    data={mapRiskToChartData(risk)}
                    height={320}
                    title={makeChartHumidityRiskTitle(risk, crop.persianName)}
                    titleFontSize="12px"
                    labelsFontSize="10px"
                    color={risk.type === "ABOVE" ? "red" : "blue"}
                    yAxisTitle="درصد احتمال"
                    decimalNumber={0}
                  />
                ))
              )}
            </div>

            <div className=" w-full flex flex-col justify-center items-center">
              <Title>درصد احتمال وقوع رطوبت محیط بالا در هر ماه</Title>
              <p className="text-[16px] !font-[B-Nazanin]">
                بر اساس اطلاعات هواشناسی 30 سال گذشته
              </p>
            </div>
          </div>
        </div>

        <NoteBox>
          براساس گزارش‌های علمی، رطوبت هوای بالاتر از مقدار تعریف شده در نمودار
          بالا می‌تواند باعث ایجاد مشکلاتی برای محصول شود.
        </NoteBox>
      </div>
    </ReportTemplate>
  );
};

export default HumidityRisks;
